<template>
    <div>
        <p>This is only an overview. See <router-link to="/api">full API specs</router-link> for more details, including model structure.</p>
        <ul>
            <li>GET /ping <span class="comment"> // returns "pong"</span></li>
            <li>POST /clear <span class="comment"> // empty DB and start from scratch</span></li>
            <li>GET /recipes <span class="comment"> // returns list of recipes</span></li>
            <li>PUT /recipes <span class="comment"> // creates a new recipe</span></li>
            <li>GET /recipes/{id} <span class="comment"> // returns a specific recipe</span></li>
            <li>DELETE /recipes/{id} <span class="comment"> // deletes a specific recipe</span></li>
            <li>POST /recipes/{id}/make <span class="comment"> // Yummy!</span></li>
            <li>GET /inventory <span class="comment"> // get current inventory</span></li>
            <li>POST /inventory <span class="comment"> // adds more items to inventory</span></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ApiOverview'
}
</script>


<style scoped>
.comment {
    color: #666666;
}
</style>